"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var price_1 = require("./price");
function SET_FIELD(state, key) {
    var field = state[key.name];
    field.error = key.error;
    field.touched = true;
    field.valid = key.valid;
    field.value = key.value;
    field.warning = key.warning;
    state[key.name] = field;
}
exports.SET_FIELD = SET_FIELD;
function SET_VALID(state, valid) {
    state.allFieldsValid = valid;
}
exports.SET_VALID = SET_VALID;
function IMPORT_FORM_VALIDATIONS(state, formValidations) {
    state.formValidations = formValidations;
}
exports.IMPORT_FORM_VALIDATIONS = IMPORT_FORM_VALIDATIONS;
function IMPORT_PAYMENT_COUNTRIES(state, countries) {
    state.paymentCountries = countries;
}
exports.IMPORT_PAYMENT_COUNTRIES = IMPORT_PAYMENT_COUNTRIES;
function SET_PRIMARY_PAX_ID(state, index) {
    state.primaryPaxId = index;
}
exports.SET_PRIMARY_PAX_ID = SET_PRIMARY_PAX_ID;
function SET_INSURANCE_BOOKED(state, value) {
    state.insuranceBooked = value;
}
exports.SET_INSURANCE_BOOKED = SET_INSURANCE_BOOKED;
function SET_INSURANCE_TERMS(state, value) {
    state.insuranceConditionsAccepted = value;
}
exports.SET_INSURANCE_TERMS = SET_INSURANCE_TERMS;
function SET_INSURANCE_TERMS_ERROR(state, value) {
    state.insuranceConditionsAcceptedHasError = value;
}
exports.SET_INSURANCE_TERMS_ERROR = SET_INSURANCE_TERMS_ERROR;
function SET_IPP_BOOKED(state, value) {
    state.ippBooked = value;
}
exports.SET_IPP_BOOKED = SET_IPP_BOOKED;
function SET_IPP_ACCEPTED(state, value) {
    state.ippField.value = value;
    state.ippField.valid = true;
    state.ippField.error = false;
}
exports.SET_IPP_ACCEPTED = SET_IPP_ACCEPTED;
function SET_IPP_ACCEPTED_ERROR(state, value) {
    state.ippField.error = value;
    state.ippField.touched = true;
}
exports.SET_IPP_ACCEPTED_ERROR = SET_IPP_ACCEPTED_ERROR;
function SET_TERMS(state, value) {
    state.tradingConditionsAccepted = value;
}
exports.SET_TERMS = SET_TERMS;
function SET_TERMS_ERROR(state, value) {
    state.tradingConditionsAcceptedHasError = value;
}
exports.SET_TERMS_ERROR = SET_TERMS_ERROR;
function SET_COVID_NOTE(state, value) {
    state.covidNoteAccepted = value;
}
exports.SET_COVID_NOTE = SET_COVID_NOTE;
function SET_COVID_NOTE_ERROR(state, value) {
    state.covidNoteAcceptedHasError = value;
}
exports.SET_COVID_NOTE_ERROR = SET_COVID_NOTE_ERROR;
function SET_FORM_SHEET_PAUSCHAL(state, value) {
    state.formSheetPauschal = value;
}
exports.SET_FORM_SHEET_PAUSCHAL = SET_FORM_SHEET_PAUSCHAL;
function SET_FORM_SHEET_PAUSCHAL_ERROR(state, value) {
    state.formSheetPauschalHasError = value;
}
exports.SET_FORM_SHEET_PAUSCHAL_ERROR = SET_FORM_SHEET_PAUSCHAL_ERROR;
function SET_PRICE(state, price) {
    state.price = new price_1.Price(price.fullPrice, price.deposit, price.outstanding, price.deadline);
}
exports.SET_PRICE = SET_PRICE;
function SET_FORM_PDF(state, value) {
    state.formPDF = value;
}
exports.SET_FORM_PDF = SET_FORM_PDF;
exports.default = {
    IMPORT_FORM_VALIDATIONS: IMPORT_FORM_VALIDATIONS,
    IMPORT_PAYMENT_COUNTRIES: IMPORT_PAYMENT_COUNTRIES,
    SET_PRIMARY_PAX_ID: SET_PRIMARY_PAX_ID,
    SET_FIELD: SET_FIELD,
    SET_VALID: SET_VALID,
    SET_INSURANCE_TERMS: SET_INSURANCE_TERMS,
    SET_INSURANCE_TERMS_ERROR: SET_INSURANCE_TERMS_ERROR,
    SET_TERMS: SET_TERMS,
    SET_TERMS_ERROR: SET_TERMS_ERROR,
    SET_COVID_NOTE: SET_COVID_NOTE,
    SET_COVID_NOTE_ERROR: SET_COVID_NOTE_ERROR,
    SET_FORM_SHEET_PAUSCHAL: SET_FORM_SHEET_PAUSCHAL,
    SET_FORM_SHEET_PAUSCHAL_ERROR: SET_FORM_SHEET_PAUSCHAL_ERROR,
    SET_INSURANCE_BOOKED: SET_INSURANCE_BOOKED,
    SET_PRICE: SET_PRICE,
    SET_IPP_BOOKED: SET_IPP_BOOKED,
    SET_IPP_ACCEPTED: SET_IPP_ACCEPTED,
    SET_IPP_ACCEPTED_ERROR: SET_IPP_ACCEPTED_ERROR,
    SET_FORM_PDF: SET_FORM_PDF,
};
//# sourceMappingURL=mutations.js.map